import { apiSlice } from "app/api/apiSlice"

export const locationsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Locations'],
    endpoints: builder => ({

        getLocations: builder.query({
            query: () => 'utility/locations',
            keepUnusedDataFor: 5,
            providesTags: ['Locations']
        })
    })
})

export const {
    useGetLocationsQuery
} = locationsApiSlice
